export type Student = {
  id: string
  firstName: string
  lastName: string
  grade: string
  school: string
  attendanceRate: number // percentage
  absences: number
  literacyScore: number // Lexile
  literacyLevel: 'On Track' | 'Approaching' | 'Needs Support'
  history: { date: string; score: number }[]
  lastTestDate: string
  nextTestDate: string
  lettersSent: number
  isBeginningReader?: boolean
}

export type Campaign = {
  id: string
  name: string
  status: 'Active' | 'Scheduled' | 'Draft' | 'Completed'
  windowStart: string
  windowEnd: string
  lettersScheduled: string
  studentsCount: number
  completionRate: number
}

export const students: Student[] = [
  {
    id: '1',
    firstName: 'Maya',
    lastName: 'Johnson',
    grade: '3rd Grade',
    school: 'Lincoln Elementary',
    attendanceRate: 96,
    absences: 3,
    literacyScore: 650,
    literacyLevel: 'On Track',
    history: [
      { date: '2023-09-15', score: 520 },
      { date: '2024-01-10', score: 590 },
      { date: '2024-04-12', score: 650 },
    ],
    lastTestDate: 'Apr 12, 2024',
    nextTestDate: 'Oct 15, 2024',
    lettersSent: 2,
  },
  {
    id: '2',
    firstName: 'Leo',
    lastName: 'Rivera',
    grade: '3rd Grade',
    school: 'Lincoln Elementary',
    attendanceRate: 82,
    absences: 14,
    literacyScore: 410,
    literacyLevel: 'Needs Support',
    history: [
      { date: '2023-09-15', score: 380 },
      { date: '2024-01-10', score: 395 },
      { date: '2024-04-12', score: 410 },
    ],
    lastTestDate: 'Apr 12, 2024',
    nextTestDate: 'Oct 15, 2024',
    lettersSent: 2,
  },
  {
    id: '3',
    firstName: 'Sam',
    lastName: 'Chen',
    grade: '3rd Grade',
    school: 'Lincoln Elementary',
    attendanceRate: 98,
    absences: 1,
    literacyScore: 580,
    literacyLevel: 'Approaching',
    history: [
      { date: '2023-09-15', score: 450 },
      { date: '2024-01-10', score: 510 },
      { date: '2024-04-12', score: 580 },
    ],
    lastTestDate: 'Apr 12, 2024',
    nextTestDate: 'Oct 15, 2024',
    lettersSent: 2,
  },
  {
    id: '4',
    firstName: 'Zoe',
    lastName: 'Williams',
    grade: '1st Grade',
    school: 'Washington Primary',
    attendanceRate: 92,
    absences: 6,
    literacyScore: 0,
    isBeginningReader: true,
    literacyLevel: 'Approaching',
    history: [
      { date: '2023-09-15', score: 0 },
      { date: '2024-01-10', score: 0 },
    ],
    lastTestDate: 'Jan 10, 2024',
    nextTestDate: 'May 20, 2024',
    lettersSent: 1,
  },
  {
    id: '5',
    firstName: 'James',
    lastName: 'Smith',
    grade: '5th Grade',
    school: 'Lincoln Elementary',
    attendanceRate: 88,
    absences: 9,
    literacyScore: 1310,
    literacyLevel: 'On Track',
    history: [
      { date: '2023-09-15', score: 1250 },
      { date: '2024-01-10', score: 1310 },
    ],
    lastTestDate: 'Jan 10, 2024',
    nextTestDate: 'May 20, 2024',
    lettersSent: 1,
  },
]

export const campaigns: Campaign[] = [
  {
    id: 'c1',
    name: 'Fall 2024 Literacy Update',
    status: 'Active',
    windowStart: 'Sep 1, 2024',
    windowEnd: 'Oct 15, 2024',
    lettersScheduled: 'Oct 30, 2024',
    studentsCount: 3450,
    completionRate: 68,
  },
  {
    id: 'c2',
    name: 'Winter 2025 Progress',
    status: 'Scheduled',
    windowStart: 'Jan 10, 2025',
    windowEnd: 'Feb 15, 2025',
    lettersScheduled: 'Feb 28, 2025',
    studentsCount: 3450,
    completionRate: 0,
  },
  {
    id: 'c3',
    name: 'Spring 2024 Review',
    status: 'Completed',
    windowStart: 'Apr 1, 2024',
    windowEnd: 'May 15, 2024',
    lettersScheduled: 'May 30, 2024',
    studentsCount: 3420,
    completionRate: 100,
  },
]

export const stats = {
  totalStudents: 3450,
  onTrack: 62,
  approaching: 24,
  needsSupport: 14,
  lettersGenerated: 12500,
  avgAttendance: 94.2,
}
